import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const Todo = ({
  todos,
  id,
  completed,
  changeProcessTodo,
  deleteTodo,
  changeTodoItem,
}) => {
  const [editing, setEditing] = useState(false);
  const [editedTodo, setEditedTodo] = useState('');

  const handleEdit = (event) => {
    if (event.key === 'Enter' && editedTodo) {
      changeTodoItem(id, editedTodo);
      setEditing(false);
      setEditedTodo('');
    } else if (event.key === 'Enter' && !editedTodo) {
      deleteTodo(id);
      setEditing(false);
      setEditedTodo('');
    }

    if (event.key === 'Escape') {
      setEditedTodo('');
      setEditing(false);
    }
  };

  const handleSaveChanges = () => {
    if (editedTodo) {
      changeTodoItem(id, editedTodo);
      setEditing(false);
      setEditedTodo('');
    } else {
      setEditing(false);
      setEditedTodo('');
    }
  };

  return (
    <li className={classNames({
      completed,
      editing,
    })}
    >
      <div className="view">
        <input
          type="checkbox"
          className="toggle"
          onChange={() => changeProcessTodo(id)}
          checked={completed}
        />
        <label
          onDoubleClick={() => setEditing(true)}
        >
          {todos}
        </label>
        <button
          type="button"
          className="destroy"
          onClick={() => deleteTodo(id)}
        />
      </div>
      {editing && (
        <input
          autoFocus
          type="text"
          className="edit"
          defaultValue={todos}
          onChange={event => setEditedTodo(event.target.value)}
          onKeyDown={handleEdit}
          onBlur={handleSaveChanges}
        />
      )}
    </li>
  );
};

Todo.propTypes = {
  todos: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  completed: PropTypes.bool.isRequired,
  changeProcessTodo: PropTypes.func.isRequired,
  deleteTodo: PropTypes.func.isRequired,
  changeTodoItem: PropTypes.func.isRequired,
};
